'use strict';

(function () {
  'use strict';

  angular.module('msCore').service('AxeWrapperSvc', AxeWrapperSvc);

  AxeWrapperSvc.$inject = ['$log', '$timeout', '$window', '$rootScope', 'NotifyingSvc'];

  function AxeWrapperSvc($log, $timeout, $window, $rootScope, NotifyingSvc) {
    var queueCounter = 0;

    return {
      init: initAxe
    };

    function initAxe() {
      $window.axe.configure({ tagExclude: ['best-practice'] });

      $rootScope.$on('$stateChangeSuccess', function () {
        addToQueue();
      });

      NotifyingSvc.subscribe(NotifyingSvc.EVENTS.OPEN_MODAL, function () {
        addToQueue();
      });
    }

    function addToQueue() {
      if (queueCounter === 0) {
        queueCounter++;
        runAxe();
      } else {
        queueCounter++;
      }
    }

    function runAxe() {
      if (queueCounter) {
        $timeout(function () {
          $window.axe.run().then(function (results) {
            if (results.violations.length) {
              $log.info('Axe has detected violations on the', $window.document.title);
              results.violations.forEach(function (violation) {
                $log.error(violation.impact + ': ' + violation.help);
              });
            }
            queueCounter--;
            runAxe();
          }).catch(function (error) {
            $log.error('Something bad happened:', error);
          });
        }, 3000);
      }
    }
  }
})();